<ng-container *appIfHasPrivileges="requiredPrivileges">
  <a mat-menu-item (click)="toggleExpansion()">
    <div fxLayout="row">
      <div fxFlex>{{ title }}</div>
      <div fxFlex fxFlexFill></div>
      <div fxFlex="nogrow">
        @if (!expanded) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (expanded) {
          <mat-icon>expand_less</mat-icon>
        }
      </div>
    </div>
  </a>
  <mat-divider></mat-divider>
  @if (expanded) {
    <div class="sub-menu-container">
      <ng-content></ng-content>
    </div>
  }
</ng-container>
